var NoCacheInterceptor = /** @class */ (function () {
    function NoCacheInterceptor() {
    }
    NoCacheInterceptor.prototype.intercept = function (currentHttpRequest, next) {
        // Headers not allowed for Auth0.
        if (currentHttpRequest.url.includes('login.symagic.com') || currentHttpRequest.url.includes('auth0.com')) {
            return next.handle(currentHttpRequest);
        }
        // Clone the request and add the cache headers
        var newHttpRequest = currentHttpRequest.clone({
            setHeaders: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            }
        });
        return next.handle(newHttpRequest);
    };
    return NoCacheInterceptor;
}());
export { NoCacheInterceptor };
